module.exports = __webpack_public_path__ + "img/chrome2.e634af5d.png";